import { Author, Tags } from 'components/Pages/Blog/index';
import Image from 'components/ui/Image';
import Link from 'components/ui/Link';
import { useTranslation } from 'hooks/useTranslation';
import styles from './PostItem.module.scss';
import type { BlogItem } from 'types/Blog';

type Props = {
  fields: BlogItem;
  authorBaseSlug?: string | null;
  priorityImage?: boolean;
  className?: string;
};

const PostItem = ({
  fields,
  authorBaseSlug,
  priorityImage,
  className,
}: Props): JSX.Element => {
  const { t, locale } = useTranslation();
  const { bannerImage, slug, tags, title } = fields;

  return (
    <article className={className}>
      {fields.bannerImage && (
        <div className={styles.imageWrapper}>
          <Link href={`/${locale}/blog/${slug}`}>
            <a title={title}>
              <Image
                className={styles.image}
                src={bannerImage?.url || ''}
                alt={bannerImage?.description || bannerImage?.title || ''}
                fill
                contentful
                priority={priorityImage}
              />
            </a>
          </Link>
        </div>
      )}
      <div className={styles.content}>
        <h3 className={styles.title}>
          <Link href={`/${locale}/blog/${slug}`}>
            <a className={styles.titleLink} title={title}>
              <span className="hyphenate">{title}</span>
            </a>
          </Link>
        </h3>
        <div className={styles.excerpt}>
          {fields.excerpt}{' '}
          <Link href={`/${locale}/blog/${slug}`}>
            <a>{t('blog.readMore')}...</a>
          </Link>
        </div>
        <Author
          {...fields.author}
          authorBaseSlug={authorBaseSlug}
          imageSize={64}
        />

        {tags && (
          <div className={styles.tags}>
            <Tags tags={tags.items} showHeadline={false} />
          </div>
        )}
      </div>
    </article>
  );
};

export default PostItem;
